const slideItems = [
  {
    id: 1,
    bigImg: "https://i.imgur.com/jnbO7CU.jpg",
  },
  {
    id: 3,
    bigImg: "https://i.imgur.com/GqmGzhV.png",
  },
  {
    id: 4,
    bigImg: "https://i.imgur.com/lF5psHf.jpeg",
  },
  {
    id: 6,
    bigImg: "https://i.ytimg.com/vi/6Cc5RvwUbq0/maxresdefault.jpg",
  },
  {
    id: 7,
    bigImg: "https://i.imgur.com/DCzfG9A.jpg",
  },
  {
    id: 8,
    bigImg: "https://technomood.org/wp-content/uploads/2018/07/90310.jpg",
  },
  {
    id: 9,
    bigImg: "https://i.imgur.com/5MUedLV.png",
  },
  {
    id: 10,
    bigImg:
      "https://images.squarespace-cdn.com/content/v1/56c346b607eaa09d9189a870/1558473888522-6VBJX4RKBAP438MGW592/Tale+Of+Us_Flaunt_3.jpg?format=1000w",
  },
  {
    id: 11,
    bigImg: "https://i.imgur.com/5231MXp.jpg",
  },
];
slideItems.sort(function () {
  return Math.floor(Math.random() - 0.5);
});

export default slideItems;
